import { FormType, InputType, ReactiveDropdownCatalogs } from '@fitogest/reactive-form-builder/interfaces';
import { TareaEdificiosModel } from '../../../../../../models/tareas/tarea-edificios.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export class TareasEdificiosFormDefinition extends MtoReactiveFormDefinition<TareaEdificiosModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaEdificiosModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'edificios',
            header: 'Datos de edificios',
            database: 'tareas_edificios',
            signatureFolder: 'edificios',
            sections: this.getSections(),
            dropdownCatalogs: this.getDropdownCatalogs(),
        });
    }


    private getDropdownCatalogs(): ReactiveDropdownCatalogs {
        return {
            critical: ['id_finca'],
            deferred: ['id_cliente', 'ids_trabajadores'],
            lazy: [],
        };
    }

    private getSections(): MtoSectionSpec<TareaEdificiosModel>[] {
        return [
            { name: 'Datos de edificios', fields: [...this.getDefaultMainFieldSpecs({ includeHours: false, includeMantenimiento: false })] },
            { name: 'Jardín', fields: [
                this.hourField('hora_inicio_jardin', 'Hora Inicio'),
                this.hourField('hora_fin_jardin', 'Hora Fin'),
                this.hourTotalField('horas_jardin', 'Horas totales', 'hora_inicio_jardin', 'hora_fin_jardin'),
            ] },
            { name: 'Piscina', fields: [
                this.hourField('hora_inicio_piscina', 'Hora Inicio'),
                this.hourField('hora_fin_piscina', 'Hora Fin'),
                this.hourTotalField('horas_piscina', 'Horas totales', 'hora_inicio_piscina', 'hora_fin_piscina'),
            ] },
            { name: 'Tareas de piscina', fields: [
                this.field('barredera', `Barredera`, InputType.SWITCH, { width: 3 }),
                this.field('cepillado', `Cepillado Paredes/Fondo`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_red', `Limpieza con Red`, InputType.SWITCH, { width: 3 }),
                this.field('rascado_linea_flotacion', `Rascado Línea Flotación`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Comprobación de parámetros', fields: [
                this.field('comprobar_parametros_ph', `Ph`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_cloro', `Cloro`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_acido_isocianurico', `Acido Isocianurico`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_alcalinidad', `Alcalinidad`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_fosfatos', `Fosfatos`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_observaciones', `Observaciones`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Limpieza y mantenimiento piscina', fields: [
                this.field('lavado_enjuague_cesti', `Lavado/Enjuague/Cesto Bomba`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_duchas', `Limpieza Duchas`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_skimmer', `Limpieza Skimmer`, InputType.SWITCH, { width: 3 }),
                this.field('nivel_vaso', `Nivel del Vaso`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_cuarto_depuradora', `Limpieza Cuarto Depuradora`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Cloro', fields: [
                this.field('cloro_liquido', `Líquido (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('cloro_granulado', `Granulado (kilos)`, InputType.NUMERIC, { width: 3 }),
                this.field('cloro_pastillas', `Pastillas`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Floculante', fields: [
                this.field('floculante_liquido', `Líquido (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('floculante_pastillas', `Pastillas`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Productos piscina', fields: [
                this.field('coagulante', `Coagulante (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('algicida', `Algicida (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('alcalinidad', `Alcalinidad (kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('ph_minus', `PH- (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('ph_plus', `PH+ (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('activador', `Activador (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('enzimatic', `Enzimatic (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('desincrustante', `Desincrustante (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('eliminador_fosfatos', `Eliminador Fosfatos (kg)`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Recambios piscina', fields: [
                this.field('arena_silice', `Arena Sílice (25kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('limpiador_silex', `Limpiador Silex (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('vidrio', `Vidrio (20kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('sacos_sal', `Sacos Sal (25kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('limpiador_fotocelulas', `Limpiador Fotocelulas (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('cesto_skimmer', `Cesto Skimmer`, InputType.NUMERIC, { width: 3 }),
                this.field('tapas_skimmer', `Tapas Skimmer`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_sumidero', `Rejillas Sumidero`, InputType.NUMERIC, { width: 3 }),
                this.field('foco_luz', `Foco Luz`, InputType.NUMERIC, { width: 3 }),
                this.field('alcachofa_ducha', `Alcachofa Ducha`, InputType.NUMERIC, { width: 3 }),
                this.field('pomo_sencilla', `Pomo Sencilla`, InputType.NUMERIC, { width: 3 }),
                this.field('pomo_completo', `Pomo Completo`, InputType.NUMERIC, { width: 3 }),
                this.field('red_piscina', `Red Piscina`, InputType.NUMERIC, { width: 3 }),
                this.field('pertiga', `Pertiga`, InputType.NUMERIC, { width: 3 }),
                this.field('bomba', `Bomba`, InputType.NUMERIC, { width: 3 }),
                this.field('cesto_bomba', `Cesto Bomba`, InputType.NUMERIC, { width: 3 }),
                this.field('escalera', `Escalera`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_transversales', `Rejillas Transversales`, InputType.NUMERIC, { width: 3 }),
                this.field('impulsores_boquilla', `Impulsores/Boquilla`, InputType.NUMERIC, { width: 3 }),
                this.field('neat_clean', `Neat Clean`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificadores_orp', `Dosificadores ORP`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificadores_ph', `Dosificadores PH`, InputType.NUMERIC, { width: 3 }),
                this.field('sonda_orp', `Sonda ORP`, InputType.NUMERIC, { width: 3 }),
                this.field('sonda_ph', `Sonda PH`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificador_pastillas', `Dosificador Pastillas`, InputType.NUMERIC, { width: 3 }),
                this.field('manometro', `Manómetro`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Limpieza general', fields: [
                this.hourField('hora_inicio_limpieza_general', 'Hora Inicio'),
                this.hourField('hora_fin_limpieza_general', 'Hora Fin'),
                this.hourTotalField('horas_limpieza_general', 'Horas totales', 'hora_inicio_limpieza_general', 'hora_fin_limpieza_general'),
            ] },
            { name: 'Recambios luces', fields: [
                this.field('luces_R90', `R90 LED`, InputType.NUMERIC, { width: 3 }),
                this.field('luces_11W', `11W Bajo Consumo`, InputType.NUMERIC, { width: 3 }),
                this.field('luces_18ww', `18ww LED (Tubo Fluoresc.)`, InputType.NUMERIC, { width: 3 }),
                this.field('luces_26W', `26W Bajo Consumo (Tubo Fluoresc.)`, InputType.NUMERIC, { width: 3 }),
                this.field('luces_14w', `14w Tubo Fluorescente`, InputType.NUMERIC, { width: 3 }),
                this.field('luces_22w', `22w LED (Tubo Fluoresc.)`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Papel higiénico', fields: [
                this.field('papel_higienico', ``, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Recambios rejillas', fields: [
                this.field('rejillas_200x500', `Desagües 200x500`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_130x500', `Desagües 130x500`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_transversales_curva_alta', `Transversales P. Curva Alta 22`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Productos limpieza', fields: [
                this.field('fregasuelos_5l', `Fregasuelos 5l`, InputType.NUMERIC, { width: 3 }),
                this.field('escoba_interior', `Escoba Interior`, InputType.NUMERIC, { width: 3 }),
                this.field('escoba_exterior', `Escoba Exterior`, InputType.NUMERIC, { width: 3 }),
                this.field('recogedor', `Recogedor`, InputType.NUMERIC, { width: 3 }),
                this.field('palo_escoba', `Palo Escoba`, InputType.NUMERIC, { width: 3 }),
                this.field('fregona_algodon', `Fregona Algodón`, InputType.NUMERIC, { width: 3 }),
                this.field('alcohol_limpieza', `Alcohol Limpieza`, InputType.NUMERIC, { width: 3 }),
                this.field('recogedor_palo', `Recogedor Palo`, InputType.NUMERIC, { width: 3 }),
                this.field('lejia_5l', `Lejia 5l`, InputType.NUMERIC, { width: 3 }),
                this.field('lejia_1l', `Lejia 1l`, InputType.NUMERIC, { width: 3 }),
                this.field('salfuman_5l', `Salfuman 5l`, InputType.NUMERIC, { width: 3 }),
                this.field('salfuman_1l', `Salfuman 1l`, InputType.NUMERIC, { width: 3 }),
                this.field('amoniaco', `Amoniaco`, InputType.NUMERIC, { width: 3 }),
                this.field('limpiacristales', `Limpiacristales`, InputType.NUMERIC, { width: 3 }),
                this.field('antical', `Antical`, InputType.NUMERIC, { width: 3 }),
                this.field('abrillantador', `Abrillantador`, InputType.NUMERIC, { width: 3 }),
                this.field('saca_de_trapos', `Saca de Trapos`, InputType.NUMERIC, { width: 3 }),
                this.field('lana_de_roca', `Lana de Roca`, InputType.NUMERIC, { width: 3 }),
                this.field('cristalizador', `Cristalizador`, InputType.NUMERIC, { width: 3 }),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
